import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import moment from 'moment';
import WireCaption from '../common/wire-caption';
import BookmarkedWireTitle from './bookmarked-wire-title';
import Avatar from '../../../shared/avatar-small';
import dt from '../../../../shared/theme';

const Container = styled.section`
  > div.wire-author {
    font-weight: ${props => dt(props).theme.fontWeightDccc};
    font-size: 14px;
    display: flex;
    align-items: flex-start;

    > p {
      color: ${props => dt(props).theme.secondaryColor};
      font-size: 16px;
      display: flex;
      flex-direction: column;
      margin: 0 0 0 16px;

      span {
        line-height: 18px;
        font-weight: 500;

        > a {
          color: ${props => dt(props).theme.secondaryColor};
          transition: none;
          text-transform: uppercase;
          font-weight: 700;
          :hover {
            text-decoration: none;
          }
        }
      }
    }
  }

  ${props => (dt(props).theme.isMobile ? `
    margin: 0 -20px;
    padding: 12px 20px 7px;
  ` : `
    margin: 0;
    padding-bottom: 15px;
  `)};

  border: none;

  .wire__summary > .clampped-summary {
    em {
      font-style: normal;
      font-weight: ${props => dt(props).theme.fontWeightHeavy};
    }

    .show-more {
      font-weight: ${props => dt(props).theme.fontWeightHeavy};
    }
  }
`;

const CaptionRow = styled.div`
  display: flex;
  font-family: ${props => dt(props).theme.fontFamilyBody};
  font-weight: ${props => dt(props).theme.fontWeightHeavy};
  ${props => (dt(props).theme.isMobile ? `
    font-size: 10px;
    line-height: 18px;
    margin-bottom: 8px;
  ` : `
    font-size: 12px;
    line-height: 12px;
  `)};
  text-transform: uppercase;
  justify-content: space-between;
  align-content: center;

  > span.main {
    color: ${props => dt(props).theme.primaryColor};
  }
  > span.secondary {
    color: ${props => dt(props).theme.secondaryColor};
  }
`;

const LastSaved = styled.div`
  color: ${props => dt(props).theme.secondaryColor};
  font-size: ${props => (dt(props).theme.isMobile ? 13 : 15)}px;
`;

const Line = styled.div`
  margin-top: 6px;
  width: 100%;
  height: 0px;
  border-bottom: 1px solid ${props => dt(props).theme.secondaryColorLight};
  display: inline-block;
`;

export default function Wire({ wire }) {
  return (
    <Container>
      {!!wire.firstPublishedAt && (
        <CaptionRow>
          <span className="main">
            <WireCaption wire={wire} />
          </span>
        </CaptionRow>
      )}
      <BookmarkedWireTitle wire={wire} />
      {!wire.firstPublishedAt && !!wire.updatedAt && (
        <LastSaved>
          {`Last saved on ${moment(wire.updatedAt).format('MMMM Do YYYY @ h:mm:ss a')}`}
        </LastSaved>
      )}
      <div className="wire-author">
        <Avatar
          name={wire.profile.name}
          profilePictureUrl={wire.profile.profilePictureUrl}
          profileUrl={wire.profileUrl}
        />
        <p>
          <span>
            { wire.profileUrl
              ? <a href={wire.profileUrl}>{wire.profile.name}</a>
              : wire.profile.name }
          </span>
          <span>{ wire.profile.position }</span>
        </p>
      </div>
      <Line />
    </Container>
  );
}

Wire.propTypes = {
  wire: PropTypes.shape({
    id: PropTypes.number.isRequired,
    firstPublishedAt: PropTypes.string.isRequired,
    updatedAt: PropTypes.string.isRequired,
    profileUrl: PropTypes.string.isRequired,
    profile: PropTypes.shape({
      name: PropTypes.string,
      profilePictureUrl: PropTypes.string,
      position: PropTypes.string.isRequired,
    }),
  }).isRequired,
};
